import * as React from 'react';

const SadFaceFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 1.548a6.452 6.452 0 1 0 0 12.904A6.452 6.452 0 0 0 8 1.548M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.935 5.935a1.032 1.032 0 1 1-2.064 0 1.032 1.032 0 0 1 2.064 0m6.194 0a1.032 1.032 0 1 1-2.064 0 1.032 1.032 0 0 1 2.064 0M8 8.258c1.81 0 2.923.66 3.399 1.04.884.704-.019 1.964-.964 1.21-.254-.201-1.003-.702-2.435-.702s-2.18.5-2.434.703c-.958.762-1.876-.486-.965-1.211.476-.38 1.59-1.04 3.399-1.04"
  }
));
SadFaceFilled16.Size = 16;
SadFaceFilled16.Title = "SadFaceFilled";

export { SadFaceFilled16 as default };
